export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.2-1204.07",
  commitId: "96e460016fb1d20980f9026bf023a560126f922d",
  commitTime: "2026-10-02T12:04:07.000Z",
});
